import type { StoryGroup } from "Components/Stories/StoriesSection";
import type { StoryDetailDto } from "Infrastructure/Api/Api";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

/**
 * Adapts a managed story (our DB record) to the shape the customer-facing StoryViewer plays, so
 * the management preview IS the real player. One-story group, never read, no watched-state
 * reporting (the preview parent ignores onStoryViewed). The author avatar is intentionally left
 * out — the management DTO carries no profile picture; Mo.one's logo still resolves client-side.
 */
export const toPreviewStoryGroup = (detail: StoryDetailDto): StoryGroup => {
  const { summary } = detail;

  return {
    actorId: summary.authorPublicID,
    actorName: summary.authorName,
    authorKind:
      summary.authorAccessRoleCode === AccessRoleCodes.Admin
        ? "moone"
        : "merchant",
    isRead: false,
    stories: [
      {
        id: summary.publicID,
        imageUrl: summary.imageUrl ?? undefined,
        videoUrl: summary.videoUrl ?? undefined,
        text: summary.text ?? undefined,
        buttonLabel: detail.buttonLabel ?? undefined,
        buttonUrl: detail.buttonUrl ?? undefined,
        sheetTitle: detail.sheetTitle ?? undefined,
        sheetDescription: detail.sheetDescription ?? undefined,
        sheetPrice: detail.sheetPrice ?? undefined,
        sheetPriceNote: detail.sheetPriceNote ?? undefined,
        sheetImageUrl: detail.sheetImageUrl ?? undefined,
        time: summary.lastPublishedAt ?? summary.dateCreated,
        isRead: false,
      },
    ],
  };
};
